<section class="flex container">
	<app-header></app-header>
	@if (stepActive$ | async; as step) {
		<bci-wk-stepper-horizontal [steps]="steps" [active]="step"></bci-wk-stepper-horizontal>
		<app-loader></app-loader>
		<div [class.hidden]="loader$ | async">
			<router-outlet></router-outlet>
		</div>
	}
	<app-snackbar></app-snackbar>
	<app-survey></app-survey>
	<app-footer></app-footer>
</section>
